import Radio from "components/radio";
import { useState } from "react";
import { errorToast } from "services/globalFunctions";

export default function Teachers(props) {
  const { setShowModal } = props;

  const [selectedValue, setSelectedValue] = useState(-1);

  const getTeachersRadio = () => {
    var teacherRadioList = [];
    for (let i = 0; i < props.data.length; i++) {
      teacherRadioList.push(
        <Radio
          value={i}
          onClick={(e) => setSelectedValue(e.target.value)}
          key={"radio" + i}
          name="type"
          color="orange"
          label={
            props.data[i].lastname[0].toUpperCase() +
            ". " +
            props.data[i].firstname +
            " - " +
            props.data[i].username
          }
        />
      );
    }
    return teacherRadioList;
  };

  return (
    <div>
      <div className="grid grid-cols-2">
        <h3 className="text-2xl font-semibold">Багш сонгох</h3>
        <button
          className="float-right ml-auto border-0 p-1 text-3xl font-semibold leading-none text-black outline-none focus:outline-none"
          onClick={() => setShowModal(false)}
        >
          ×
        </button>
      </div>
      {/*body*/}
      <div className="relative max-h-96 flex-auto overflow-x-hidden p-6">
        {getTeachersRadio()}
      </div>
      {/*footer*/}
      <div className="border-slate-200 flex items-center justify-end rounded-b border-t border-solid p-6">
        <button
          className="background-transparent mr-1 mb-1 px-6 py-2 text-sm font-bold uppercase text-red-500 outline-none transition-all duration-150 ease-linear focus:outline-none"
          type="button"
          onClick={() => props.back()}
        >
          Буцах
        </button>
        <button
          className="active:bg-emerald-600 mr-1 mb-1 rounded bg-orange-400 px-6 py-3 text-sm font-bold uppercase text-white shadow outline-none transition-all duration-150 ease-linear hover:shadow-lg focus:outline-none"
          type="button"
          onClick={() => {
            if (selectedValue === -1) {
              errorToast("Багш сонгоно уу!");
            } else {
              props.handleSubmit(selectedValue);
            }
          }}
        >
          Дараах
        </button>
      </div>
    </div>
  );
}
